export default "__VITE_ASSET__CMqVLe08__"